import React from "react";
import { connect } from "react-redux";
import BatchProcessingHistory from "../../../components/BatchProcessingHistory";
import { batchProcessingConfigs } from "../../../components/BatchProcessingHistory/configs";

const BulkOrderUploadHistory = (props) => {
  return (
    <BatchProcessingHistory
      {...props}
      config={batchProcessingConfigs.batchProcessingBulkOrderUpload}
    />
  );
};

const mapState = ({ bulkOrderLog, session }) => {
  return {
    bulkOrderUploadsList: bulkOrderLog?.orders || [],
    totalItems: bulkOrderLog?.totalItems || 0,
    user: session.user,
    fetching: bulkOrderLog?.fetching || false,
    fetched: bulkOrderLog?.fetched || false,
  };
};

export default connect(mapState)(BulkOrderUploadHistory);
